import React from "react";
import StdDownloadDemandLetter from "../../components/StudentTabs/StudentDownloadDemandLetter/StdDownloadDemandLetter";

const DownloadDemand= () => {
  return (
    <div>
      
      <StdDownloadDemandLetter/>
    </div>
  );
};

export default DownloadDemand;